import { render } from "./ArrowUpIcon.vue?vue&type=template&id=6317bc9b"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/ArrowUpIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6317bc9b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6317bc9b', __exports__)) {
    api.reload('6317bc9b', __exports__)
  }
  
  module.hot.accept("./ArrowUpIcon.vue?vue&type=template&id=6317bc9b", () => {
    api.rerender('6317bc9b', render)
  })

}


export default __exports__